/* Veyora forside · effekter for Aurora (Shopify)
   Alt er progressiv forbedring: uten JS vises siden ferdig og rolig. */
(function () {
  var html = document.documentElement;
  var rm = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  html.classList.add('vf-js');

  /* Høyden på den faste toppmenyen (temaets header) */
  function topH() {
    var h = document.querySelector('.vy-top, .header, [id^="shopify-section"][id*="header"] .header, .shopify-section-group-header-group');
    if (!h) return 0;
    var cs = getComputedStyle(h);
    return (cs.position === 'sticky' || cs.position === 'fixed') ? h.getBoundingClientRect().height : 0;
  }

  /* ---- meldingslinjen: meldingene bytter rolig ---- */
  var abSpans = [].slice.call(document.querySelectorAll('.vf-ab__slot span'));
  var abI = 0, abTimer;
  function abGo(n) { if (abSpans.length < 2) return; abSpans[abI].classList.remove('vf-on'); abI = (abI + n + abSpans.length) % abSpans.length; abSpans[abI].classList.add('vf-on'); }
  function abStart() { clearInterval(abTimer); if (!rm && abSpans.length > 1) abTimer = setInterval(function () { abGo(1); }, 4800); }
  document.addEventListener('click', function (e) { var b = e.target.closest('[data-vf-ab]'); if (b) { abGo(parseInt(b.getAttribute('data-vf-ab'), 10)); abStart(); } });
  abStart();

  /* ---- toppmeny på små skjermer: Meny / Lukk ---- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-vf-meny]');
    var topp = document.querySelector('.vf-topp');
    if (!topp) return;
    if (b) {
      var open = topp.classList.toggle('vf-meny-apen');
      var panel = document.getElementById(b.getAttribute('aria-controls'));
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (panel) panel.hidden = !open;
      var t = b.querySelector('[data-vf-meny-tekst]'); if (t) t.textContent = open ? 'Lukk' : 'Meny';
    } else if (!e.target.closest('.vf-topp') && topp.classList.contains('vf-meny-apen')) {
      topp.classList.remove('vf-meny-apen');
      var kb = topp.querySelector('[data-vf-meny]'); if (kb) { kb.setAttribute('aria-expanded', 'false'); var kt = kb.querySelector('[data-vf-meny-tekst]'); if (kt) kt.textContent = 'Meny'; }
      var kp = topp.querySelector('.vf-topp__panel'); if (kp) kp.hidden = true;
    }
  });

  /* ---- rolig avdekking ved scroll ---- */
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('vf-in'); io.unobserve(e.target); } });
  }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' }) : null;
  function observe(root) {
    [].forEach.call((root || document).querySelectorAll('.vf-rv, .vf-lines, .vf-curtain, [data-vf-observe]'), function (el) {
      if (io) io.observe(el); else el.classList.add('vf-in');
    });
  }
  observe();

  /* ---- seksjoner som ligger fast mens den neste glir over ---- */
  var pins = [];
  function setupPins() {
    pins = [].map.call(document.querySelectorAll('[data-vf-pin]'), function (el) {
      var wrap = el.closest('.shopify-section') || el;
      wrap.classList.add('vf-pinned');
      return wrap;
    });
    layoutPins();
  }
  function layoutPins() {
    var vh = window.innerHeight || 800, th = topH();
    pins.forEach(function (wrap) {
      var h = wrap.offsetHeight;
      var inner = wrap.querySelector('.vf-apning__stage');
      if (inner) h = inner.offsetHeight; /* åpningen: bare scenen skal være synlig, rullebanen ligger under */
      wrap.style.top = (h > vh - th ? (vh - h) : th) + 'px';
    });
  }

  /* ---- åpningen: bildene går ut til sidene ---- */
  var apning = document.querySelector('.vf-apning');
  var ticking = false;
  function frame() {
    ticking = false;
    var vh = window.innerHeight || 800;
    if (apning) {
      if (rm) { apning.classList.add('vf-open'); }
      else {
        /* Seksjonen ligger fast, så vi måler mot den neste seksjonen (som ikke gjør det):
           hvor langt den har kommet opp forteller hvor langt vi har scrollet inn i åpningen. */
        var wrap = apning.closest('.shopify-section') || apning;
        var next = wrap.nextElementSibling;
        var scrolled;
        if (next) { scrolled = topH() - (next.getBoundingClientRect().top - wrap.offsetHeight); }
        else { scrolled = window.scrollY - (apning.getBoundingClientRect().top + window.scrollY - topH()); }
        var p = Math.min(1, Math.max(0, scrolled / (vh * 0.85)));
        var t = Math.min(1, Math.max(0, (p - 0.3) / 0.5));
        apning.style.setProperty('--p', p.toFixed(4));
        apning.style.setProperty('--t', t.toFixed(4));
        apning.classList.toggle('vf-open', t > 0.5);
      }
    }
    if (!rm) {
      pins.forEach(function (wrap) {
        var next = wrap.nextElementSibling; if (!next) return;
        var r = next.getBoundingClientRect();
        var q = Math.min(1, Math.max(0, (vh - r.top) / vh));
        wrap.style.setProperty('--q', q.toFixed(3));
      });
    }
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () { layoutPins(); onScroll(); });
  window.addEventListener('load', function () { layoutPins(); frame(); });
  setupPins(); frame();

  /* ---- film: last YouTube først når noen trykker ---- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-vf-youtube]'); if (!b) return;
    var id = b.getAttribute('data-vf-youtube'); if (!id) return;
    var frame = b.closest('.vf-film');
    var ifr = document.createElement('iframe');
    ifr.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0&modestbranding=1';
    ifr.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
    ifr.setAttribute('allowfullscreen', '');
    ifr.title = b.getAttribute('aria-label') || 'Film';
    frame.appendChild(ifr); b.remove();
  });

  /* ---- «Legg begge i handlekurv» ---- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-vf-add-both]'); if (!b) return;
    var ids = b.getAttribute('data-vf-add-both').split(',').map(function (s) { return parseInt(s, 10); }).filter(Boolean);
    if (!ids.length) return;
    b.disabled = true; var label = b.textContent; b.textContent = 'Legger i handlekurven …';
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: ids.map(function (id) { return { id: id, quantity: 1 }; }) })
    }).then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () {
        /* Temaet (MATCHA NOW) lytter ikke på cart:refresh/cart:open, så skuffen og telleren
           ble aldri oppdatert. Vi sender kunden rett til handlekurven, der alt er riktig. */
        b.textContent = 'Lagt i handlekurven ✓';
        window.location.href = '/cart';
      })
      .catch(function () { b.disabled = false; b.textContent = label; window.location.href = '/cart'; });
  });

  /* ---- «Legg i handlekurv» på produktsiden: legg til i bakgrunnen så add_to_cart rekker å spores ---- */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.closest || !f.closest('.vy-pdp')) return;
    if ((f.getAttribute('action') || '').indexOf('/cart/add') === -1) return;
    e.preventDefault();
    var btn = e.submitter || f.querySelector('[type="submit"]');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Legger i handlekurven …'; }
    var data = new FormData(f);
    if (!data.get('quantity')) data.set('quantity', '1');
    fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: data })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () {
        /* Se kommentaren over: gå alltid til handlekurven etter at varen er lagt til.
           Liten pause så add_to_cart-sporingen rekker å sendes. Knappen holdes låst
           så kunden ikke legger til samme vare flere ganger. */
        if (btn) { btn.textContent = 'Lagt i handlekurven ✓'; }
        setTimeout(function () { window.location.href = '/cart'; }, 400);
      })
      .catch(function () { if (btn) { btn.disabled = false; btn.textContent = label; } f.submit(); });
  });

  /* Shopify sin temaredigering: kjør på nytt når en seksjon lastes inn */
  document.addEventListener('shopify:section:load', function (e) { observe(e.target); setupPins(); frame(); });
})();
